import { render } from "./UpcomingKPIView.vue?vue&type=template&id=8483764c"
import script from "./UpcomingKPIView.vue?vue&type=script&lang=js"
export * from "./UpcomingKPIView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__